/**
 * Pubsub-subscribe-remote.js
 * Subscribe to message for
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */
;(function($) {

    "use strict";

    $(function() {
        /**
         * Submit function via Ajax
         *
         * @param  Elemnt
         * @return Void
         */
        var submitAjaxRequest =function(e, f){

            /**
             * Form is the jQuery form Object
             */
            var form = $(this);

            /**
             * Define method in the form
             * We will either fake in inside the form with Laravel automatically OR default to POST
             * Verbose: Find an element of the form with name _method and get its value or set to POST
             * @type String
             */
            var method = form.find('input[name="_method"]').val() || 'POST';

            /**
             * Submit the form function
             */
            $.ajax({
                type: method,
                url:  form.prop('action'),
                data: form.serialize(),
                dataType: "html",
                success:function(response){
                    $.publish('form.submitted.success', form);
                },
                error:function() {
                    $.publish('form.submitted.error', form);
                }
            });

            e.preventDefault();
        };

        /**
         * Forms marked with data-remote attribute will submit via Ajax
         */
        $('form[data-remote]').on('submit', submitAjaxRequest);
    });

})(window.jQuery);
